// src/pages/MarketplaceIntegration/MarketplaceIntegration.jsx

import React, { useState } from 'react';
import useMarketplaceIntegration from './useMarketplaceIntegration';
import MarketplaceConnection from './MarketplaceConnection';
import ProductMatching from './ProductMatching';
import ErrorReporting from './ErrorReporting';
import MarketplaceDashboard from './MarketplaceDashboard';
import MarketplaceOrders from './MarketplaceOrders';
import './MarketplaceIntegration.css';

const MarketplaceIntegration = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const {
    marketplaces,
    loading,
    syncing,
    error,
    fetchMarketplaces,
    addMarketplace,
    updateMarketplace,
    deleteMarketplace,
    syncMarketplace
  } = useMarketplaceIntegration();

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'dashboard':
        return <MarketplaceDashboard 
          marketplaces={marketplaces} 
          onSyncMarketplace={updateMarketplace}
        />;
      case 'connections':
        return <MarketplaceConnection 
          marketplaces={marketplaces}
          onAdd={addMarketplace}
          onUpdate={updateMarketplace}
          onDelete={deleteMarketplace}
        />;
      case 'matching':
        return <ProductMatching marketplaces={marketplaces} />;
      case 'orders':
        return <MarketplaceOrders marketplaces={marketplaces} />;
      case 'errors':
        return <ErrorReporting marketplaces={marketplaces} />;
      default:
        return <MarketplaceDashboard marketplaces={marketplaces} />;
    }
  };

  if (loading) {
    return <div className="container">Yükleniyor...</div>;
  }

  return (
    <div className="marketplace-integration">
      <div className="header">
        <h1>Pazaryeri Entegrasyonu</h1>
        <p>Pazaryerleri ile stok ve sipariş entegrasyonunu yönetin</p>
      </div>

      <div className="tabs">
        <button 
          className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          Dashboard
        </button>
        <button 
          className={`tab-button ${activeTab === 'connections' ? 'active' : ''}`}
          onClick={() => setActiveTab('connections')}
        >
          Bağlantılar
        </button>
        <button 
          className={`tab-button ${activeTab === 'matching' ? 'active' : ''}`}
          onClick={() => setActiveTab('matching')}
        >
          Ürün Eşleştirme
        </button>
        <button 
          className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          Siparişler
        </button>
        <button 
          className={`tab-button ${activeTab === 'errors' ? 'active' : ''}`}
          onClick={() => setActiveTab('errors')}
        >
          Hata Raporları
        </button>
      </div>

      <div className="tab-content">
        {renderActiveTab()}
      </div>
    </div>
  );
};

export default MarketplaceIntegration;